export default __webpack_public_path__ + "static/media/wqy-MicroHei_pdf.edebb644.ttf";